import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { SharedData } from '../modules/shared/model/shared-data.model';

export class SharedDataService {
  sharedData: SharedData;
  saveData(data) {
    this.sharedData = data;
  }
  getData(): SharedData {
    return this.sharedData?? new SharedData();
  }
}
